import createAuth0Client from '@auth0/auth0-spa-js'

let auth0Client
let params = null;
async function initClient() {
  try {
    if (!auth0Client) {
      // WARNING: createAuth0Client seems to fail silently, doesn't throw error
      auth0Client = await createAuth0Client({
        domain: "dev-7urjfmg0.us.auth0.com",
        client_id: "2F3JjQd63HO3BEFqho0kxgUPzBTiAazH",
        redirect_uri: `${window.location.origin}/ssosuccess`,
        useRefreshTokens: true,
        cacheLocation: 'localstorage',
        audience: "https://www.aspenify.com/api"
      });
    }

    return auth0Client
  } catch (e) {
    console.error(e)
    alert('Auth0 failed to initiate')
  }
}
initClient().then()

export async function login(params) {
  params = params;
  const auth0 = await initClient()

  await auth0.loginWithRedirect()
}

export async function handleCallback() {
  const auth0 = await initClient();
  return await auth0.handleRedirectCallback()
}

export async function getToken() {
  const auth0 = await initClient()
  const token = await auth0.getTokenSilently()
  return token
}

export async function getUser(params) {
  const auth0 = await initClient()
  const user = await auth0.getUser(params)
  return user
}

export async function logout() {
  if (auth0Client) {
    await auth0Client.logout({
        returnTo: process.env.REACT_APP_HOST,
      })
  }
}

export default { getToken, logout, login, handleCallback, getUser }